import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { ChangePasswordComponent, ResetPasswordComponent, LoginComponent } from '@app/auth/components';
import { LoginGuard } from '@app/auth/login.guard';

const routes: Routes = [
  {
    path: 'change-password/:token/:email',
    component: ChangePasswordComponent,
    data: { title: extract('ChangePassword') }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: extract('Login') },
    canActivate: [LoginGuard]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: { title: extract('ResetPassword') },
    canActivate: [LoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AuthRoutingModule {
  static components = [LoginComponent, ResetPasswordComponent, ChangePasswordComponent];
}
